<template>
  <f7-page id="inbox"
    class="page-on-center rowBackgroundHomepage"
    data-page="inbox-page"
    :pull-to-refresh="isSmartphoneOS" @ptr:refresh="onRefresh(false)"
    infinite-scroll @infinite="onInfinite">

    <div class="layoutTop"></div>
    <div class="listPage" style="overflow:hidden;">
      <b-row>
        <b-col md="12">
          <div class="requestsList">
            <div style="margin-top:0">
              <spinner v-if="activateSpinner"></spinner>
              <div v-else style="overflow-x:auto;">
                <f7-list accordion id="directPayments-filter">
                  <!-- Affichage titre et messages filter -->
                  <f7-list-item class="filterTitle"
                    :title="listTitle" style="font-size:36px;color:#0377b5;" id="filter-item">
                    <i class="icon fa fa-filtershowSmallScreenOnly mousePointer"
                      @click="$bus.emit('right-panel-open', serviceId)" slot="content">
                    </i>
                    <div style="display:flex;position:absolute;width:300px;" slot="content"></div>
                  </f7-list-item>
                </f7-list>
                <f7-list>
                    <f7-list-item :class="additionalClass" :style="buttonsListStyle" style="background:#fcfcfcdd;">
                      <b-row style="min-width:100%;" class="justify-content-start">
                        <!-- Left section filtre -->
                        <b-col cols="2" class="d-flex flex-row showLargeScreenOnly">
                          <f7-button round class="statusButton searchFilterButton"
                            @click="refreshInbox()">
                            <f7-icon f7="refresh" style="color:darkviolet;"></f7-icon>
                            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
                          </f7-button>
                        </b-col>
                        <b-col cols="2" class="d-flex flex-row showLargeScreenOnly" style="padding: 0 30px 0 0">
                          <f7-button round class="statusButton searchFilterButton"
                            @click="displayFilter = !displayFilter">
                            <f7-icon f7="add" style="color:forestgreen;"></f7-icon>
                            {{ displayFilter ? $t('filter.hide_fltr') : $t('filter.slct_fltr') }}
                          </f7-button>
                        </b-col>
                        <!-- Right section filtre -->
                        <b-col v-bind:offset="showButtonImportLot() ? 2 : 6" class="d-flex flex-row showLargeScreenOnly" style="padding: 0 30px 0 0">
                          <f7-button round class="statusButton searchFilterButton"
                            @click="exportTransactionHistoryList()">
                            <f7-icon f7="cloud_download" style="color:sandybrown;"></f7-icon>
                            <span class="fab-label">{{ $t('common.extract_list') }}</span>
                          </f7-button>
                        </b-col>
                        <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
                        <b-col cols="12" class="showSmallScreenOnly">
                          <f7-button round class="statusButton searchFilterButton"
                            @click="$bus.emit('right-panel-open', serviceId)">
                            {{ $t('filter.slct_fltr') }}
                          </f7-button>
                        </b-col>
                        <b-col cols="5" offset="7" class="d-flex flex-row-reverse showLargeScreenOnly" v-if="displayFilter" style="margin-top:5px;">
                          <!-- Attention : les boutons s'affichent de droite à gauche -->
                          <f7-button round class="statusButton searchFilterButton"
                            :disabled="!hasDefaultFilter"
                            @click="deleteFilter">
                            {{ $t('filter.cln_fltr') }}
                          </f7-button>
                          <f7-button round class="statusButton searchFilterButton"
                            :disabled="!hasInputFilter"
                            @click="saveDefaultFilter">
                            {{ $t('filter.sv_fltr') }}
                          </f7-button>
                        </b-col>
                      </b-row>
                    </f7-list-item>

                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}"
                      class="showLargeScreenOnly" style="border: 1px solid #aaa;">
                      <b-row style="min-width:100%;">
                        <b-col class="d-flex flex-row">
                        <!-- Filtre date de début -->
                        <div class="filter-item">
                          <span class="filter-item-title">{{ 'Status payement' }}</span>
                          <span class="filter-item-content">
                            <!-- <select class="form-control" id="sel4" v-model="status" multiple readonly>
                              <option v-for="result in status_list" :key="result"
                                  :value="result">
                                  {{ $t( result) }}
                              </option>
                        </select> -->
                        <a :id="'status-picker-link' + '-' + randomString" class="filter-item-content"
                          href="#">
                          <!-- <f7-icon v-if="statusDisplay.icon" :class="statusDisplay.icon"></f7-icon> -->
                          <span>{{ 'status' }}</span>
                          <f7-icon f7="chevron_down" id="status-chevron"></f7-icon>
                        </a>
                        <b-popover :target="'status-picker-link' + '-' + randomString"
                          :title="$t('filter.selected_status_none')"
                          triggers="focus" placement="bottomright">
                          <span v-for="status in status_list" :key="status.value">
                            <b-form-checkbox v-model="status.state"
                              :value="1"
                              :unchecked-value="0">
                              <!-- <f7-icon :icon="status.icon"></f7-icon> -->
                              <span>{{ status.label }}</span>
                            </b-form-checkbox>
                          </span>
                        </b-popover>
                          </span>
                        </div>
                        <!-- Filtre date de fin -->
                        <div class="filter-item">
                          <span class="filter-item-title">{{ 'Date de Création' }}</span>
                          <span class="filter-item-content">
                            <input v-model="creation_date"
                              type="date"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': creation_date}"
                              :placeholder="'yyyy-MM-DDTHH:mm:ss.000+01:00'">
                            </input>
                          </span>
                        </div>
                        <!--Filtre endToEndId -->
                        <div class="filter-item">
                          <span class="filter-item-title">{{ 'end_to_end_id' }}</span>
                          <span class="filter-item-content">
                            <input v-model="end_to_end_id"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': end_to_end_id}"
                              :placeholder="'end_to_end_id'">
                            </input>
                          </span>
                        </div>
                        <!-- Filtre user -->
                        <div class="filter-item">
                          <span class="filter-item-title">{{ 'Bic créditeur' }}</span>
                          <span class="filter-item-content">
                            <input v-model="creditor_bic"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': creditor_bic}"
                              :placeholder="'Bic créditeur'">
                            </input>
                          </span>
                        </div>
                        <div class="filter-item">
                          <span class="filter-item-title">{{ 'Bic débiteur' }}</span>
                          <span class="filter-item-content">
                            <input v-model="debtor_bic"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': debtor_bic}"
                              :placeholder="'Bic débiteur'">
                            </input>
                          </span>
                        </div>
                      </b-col>
                      <!-- Bouton Effacer et Appliquer -->
                      <b-col cols="3" class="d-flex flex-row-reverse" style="margin-top: 10px;">
                        <f7-button round class="statusButton searchFilterButton"
                          @click="applyFilter()">
                          {{ $t('filter.appl_fltr') }}
                        </f7-button>
                        <f7-button round class="statusButton searchFilterButton"
                          @click="clearFilterFields"
                          style="max-width: fit-content" :disabled="!hasInputFilter">
                          {{ $t('filter.clr_fltr_field') }}
                        </f7-button>
                      </b-col>
                    </b-row>
                  </f7-list-item>
                </f7-list>
                <table class="sellersResults">
                  <thead>
                    <th class="text-center" style="width:250px">
                      {{ $t('Date de Création') }}
                    </th>
                    <th class="text-center" style="width:250px">
                      {{ $t('Bic crediteur') }}
                    </th>
                    <th class="text-center" style="width:250px">
                      {{ $t('Bic débiteur') }}
                    </th>
                    <th class="text-center" style="width:280px">
                      {{ $t('Date de création payement') }}
                    </th>
                    <th class="text-center" style="width:320px">
                      {{ $t('end_to_end_id') }}
                    </th>
                    <th class="text-center" style="width:400px">
                      {{ $t('Status payement') }}
                    </th>
                    <th class="text-center" style="width:150px">
                        {{ $t('Détails') }}
                    </th>
                  </thead>
                  <tbody>
                    <template v-if="ListTransactions.length > 0">
                      <tr v-for="result in ListTransactions"
                        :key="result"
                        class="boxRequest">
                        <td class="text-center" :title="result.payment_history.creation_date">{{ result.payment_history.creation_date }}</td>
                        <td class="text-center" :title="result.payment.creditor_bic">{{ result.payment.creditor_bic }}</td>
                        <td class="text-center" :title="result.payment.debtor_bic">{{ result.payment.debtor_bic}}</td>
                        <td class="text-center" :title="result.payment.creation_date">{{ result.payment.creation_date }}</td>
                        <td class="text-center" :title="result.payment.end_to_end_id">{{ result.payment.end_to_end_id}}</td>
                        <td class="text-center" :title="result.payment.status">{{ label(result.payment.status) }}</td>
                        <td class="text-center" title="Détail"
                        @click="activateDetail(result.payment_history.id_payment)">
                          <f7-icon f7="list_fill" class="buttonIcon blueIcon"/>
                        </td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td colspan="6" class="noResult">
                        {{ $t('common.no_result') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import {statusLabel} from '@/helpers/labels'
import status from '@/helpers/status'
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'TransactionHistoryList',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    /* actionDirection () {
      return ((this.sortField === 'typeAction' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    dateDirection () {
      return ((this.sortField === 'dateAction' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    endToEndIdDirection () {
      return ((this.sortField === 'endToEndId' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    userDirection () {
      return ((this.sortField === 'user' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    }, */
    listTitle () {
      return this.$t('Webheader.transactionhistorylist')
    },
    hasInputFilter () {
      if (
        this.status !== [] ||
        this.creation_date !== '' ||
        this.end_to_end_id !== '' ||
        this.creditor_bic !== '' ||
        this.debtor_bic !== '') {
        return true
      }
      return false
    }
  },
  data () {
    return {
      status: [],
      creation_date: '',
      end_to_end_id: '',
      creditor_bic: '',
      debtor_bic: '',
      activateSpinner: false,
      filterBy: {},
      ListTransactions: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      status_list: [],
      randomString: ''
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Historique des Transactions',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      // this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    this.createStatusList()

    let defaultFilter = this.$engine.transactionhistorylist.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)

    this.onRefresh()
  },
  mounted () {
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.transactionhistorylist.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.transactionhistorylist.cleanFilterCondition()
  },
  methods: {
    createStatusList () {
      for (const stat of Object.keys(status)) {
        if (stat.startsWith('RTP_')) {
          (this.status_list).push({value: status[stat], label: this.label(status[stat]), state: 0})
        }
      }
    },
    buildStatus () {
      this.status = []
      for (const el of this.status_list) {
        if (el.state === 1)
        (this.status).push(el.value)
      }
    },
    label (status) {
      return statusLabel(this.$i18n, status)
    },
    makeList (tab) {
      this.ListTransactions = tab
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/detailtransactionhistorylist/' + id})
    },
    applyFilter (filterConditions = {}) {
      let that = this
      let defaultFilter = this.$engine.history.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter)
      this.$engine.transactionhistorylist.cleanFilterCondition()
      this.$engine.transactionhistorylist.status = this.status
      // this.creation_dateF = moment(this.creation_dateF).format('yyyy-MM-DD HH:mm:ss')
      this.$engine.transactionhistorylist.creation_date = this.creation_date
      this.$engine.transactionhistorylist.end_to_end_id= this.end_to_end_id
      this.$engine.transactionhistorylist.creditor_bic = this.creditor_bic
      this.$engine.transactionhistorylist.debtor_bic = this.debtor_bic
      /* for (let propertyCustom in filterConditions) {
        this.$engine.history[propertyCustom] = filterConditions[propertyCustom]
      } */
      // filterConditions = this.$engine.transactionhistorylist.getConditionObject()
      // this.$emit('applyFilter', actualFilter.getConditionObject())

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true
      this.buildStatus()
      this.filterBy = {
        status: this.status,
        creation_date: this.creation_date,
        end_to_end_id: this.end_to_end_id,
        creditor_bic: this.creditor_bic,
        debtor_bic: this.debtor_bic
      }

      this.$engine.transactionhistorylist.getTransactionHistoryLists(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        this.filterBy
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResults = resp.data.TransactionHistoryList.length
        resp.data.TransactionHistoryList.forEach(item => {
          item.payment_history.creation_date = moment(item.payment_history.creation_date).format('DD/MM/yyyy HH:mm:ss')
        })
        requests = resp.data.TransactionHistoryList
        that.makeList(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.status = []
      this.creation_date = ''
      this.end_to_end_id = ''
      this.creditor_bic = ''
      this.debtor_bic = ''
      for (const el of this.status_list) {
        el.state = 0
      }
      // this.communicateChange()
    },
    deleteFilter () {
      for (const el of this.status_list) {
        el.state = 0
      }
      this.filterBy = {
        status: [],
        creation_date: '',
        end_to_end_id: '',
        creditor_bic: '',
        debtor_bic: ''
      }
      this.$engine.transactionhistorylist.saveDefaultFilter(this.filterBy)
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveDefaultFilter () {
      let defaultFilter = {
        status: this.status,
        creation_date: this.creation_date,
        end_to_end_id: this.end_to_end_id,
        creditor_bic: this.creditor_bic,
        debtor_bic: this.debtor_bic
      }
      this.$engine.transactionhistorylist.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }
      let that = this
      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    /* showFilterDateBegin () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterDateEnd () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterEndToEndId () {
      return this.isHistory
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.user.currentService.id) &&
        status.filterName === this.filterTypeGet
    }, */
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportTransactionHistoryList () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Status Historique' + ';' +
        'Date de création' + ';' +
        'Bic créditeur' + ';' +
        'Bic débiteur' + ';' +
        'Date de création payement' + ';' +
        'end_to_end_id' + ';' +
        'Status payement' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.ListTransactions.length; i++) {
        let result = this.ListTransactions[i]
        lines += result.payment_history.status + ';' +
                 result.payment_history.creation_date + ';' +
                 result.payment.creditor_bic + ';' +
                 result.payment.debtor_bic + ';' +
                 result.payment.creation_date + ';' +
                 result.payment.end_to_end_id + ';' +
                 result.payment.status + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'transactionhistorylist_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onClear () {
      this.filterBy = {
        status: [],
        creation_date: '',
        end_to_end_id: '',
        creditor_bic: '',
        debtor_bic: ''
      }
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        /* let filterConditions
        if (this.$engine.transactionhistorylist.getDefaultFilter()) {
          filterConditions = this.$engine.transactionhistorylist.getDefaultFilter()
        } else {
          filterConditions = this.$engine.transactionhistorylist.getConditionObject()
        }
        filterConditions.sortField = 'SF' + this.sortField
        filterConditions.sortDirection = this.sortDirection */
        this.$engine.transactionhistorylist.getTransactionHistoryLists(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          this.filterBy
        ).then(resp => {
          let requests = []
          that.requestsNumber = resp.data.TransactionHistoryList.length
          /* resp.data.TransactionHistoryList.forEach(item => {
            // item.dateAction = moment(item.dateAction).format('DD/MM/yyyy HH:mm:ss')
            // item.typeAction = this.$t('history.' + item.typeAction)
          }) */
          requests = resp.data.TransactionHistoryList
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.ListTransactions.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      // const that = this
      this.$bus.$emit('change-mobile-header', {
        backLink: false,
        navbarInnerStyle: 'justify-content:start;',
        navTitle: 'Historique des Transactions',
        returnUrl: ''
      })
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 13
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      this.$bus.$off('refresh-cache-contacts')

      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.$bus.$off('direct-inbox-filtered')
      this.$bus.$on('direct-inbox-filtered', index => {
        // this.onRefresh(false, index)
        that.pageCounter = 0
      })

      this.$f7.initPullToRefresh()
      this.pageCounter = 0
      // this.onRefresh(false)
      this.filterTypeGet = this.filterType
      this.$bus.emit('right-panel-set-feature', 'filter-messages')

      /* this.statusF = []
      this.creation_dateF = ''
      this.end_to_end_idF = ''
      this.creditor_bicF = ''
      this.debtor_bicF = '' */
      this.filterBy = this.$engine.transactionhistorylist.getDefaultFilter()
      /* this.filterBy = {
        status: this.statusF,
        creation_date: this.creation_dateF,
        end_to_end_id: this.end_to_endF,
        creditor_bic: this.creditor_bicF,
        debtor_bic: this.debtor_bicF
      } */

      this.$engine.transactionhistorylist.getTransactionHistoryLists(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        this.filterBy
      ).then(resp => {
        let requests = []
        this.paginationObject.nbResults = resp.data.TransactionHistoryList.length
        if (resp.data && resp.data.TransactionHistoryList) {
          resp.data.TransactionHistoryList.forEach(item => {
            item.payment_history.creation_date = moment(item.payment_history.creation_date).format('DD/MM/yyyy HH:mm:ss')
          })
          requests = resp.data.TransactionHistoryList
          this.makeList(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(e => {
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    /* reOrderBy (column) {
      if (this.sortField === column) {
        console.log('column :', column)
        console.log('sortField :', this.sortField)
        console.log('sortDirection:', this.sortDirection)
        // just switch order
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        // new column + default order
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.history.getDefaultFilter()) {
        filterConditions = this.$engine.history.getDefaultFilter()
      } else {
        filterConditions = this.$engine.history.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.transactionhistorylist.getTransactionHistoryLists(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.TransactionHistoryList.length
        resp.data.TransactionHistoryList.forEach(item => {
          // item.dateAction = moment(item.dateAction).format('DD/MM/yyyy HH:mm:ss')
          // item.typeAction = this.$t('history.' + item.typeAction)
        })
        requests = resp.data.TransactionHistoryList
        this.updateInbox(requests, false)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this)
      })
    }, */
    updateInbox (requests, noAttach = false) {
      this.ListTransactions = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  }
}
</script>

<style scoped>
.sellersResults {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  width: 100%;
}

.sellersResults th {
  background-color: black;
  border: 1px solid silver;
  color: white;
  font-weight: normal;
  height: 40px;
}

.sellersResults tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: white;
}

.sellersResults tbody tr td,.sellersResults thead th {
  text-align: center;
}


.filterType .label {
  width: 40%;
}
.icon-status-label {
  width: 22px;
  height: 22px;
  background-size: contain;
  margin-top: -4px;
  /* vertical-align: baseline !important; */
}

.list-block .item-title.label {
  width: auto;
}

::-webkit-input-placeholder {
  color: #A7A7A7;
}

label {
  margin-bottom: 0%;
}

.filter {
  width: 100%;
  border-radius: 0px;
  margin: 0px;
}

.filter-item-title {
  color: var(--actionTextColor);
  font-weight: 700;
}
.filter-item-content {
  color: #969696;
}
.filter-item-section {
  background-color: #f2f2f2;
}
.filter-item {
  display: inline-flex;
  flex-direction: column;
  padding-right: 2rem;
  flex: 1 1 auto;
}
input.filter-item-input, textarea.filter-item-input {
  height:auto;
  line-height:inherit;
  color:inherit;
  font-size:inherit;
}
input.filter-item-input-complete, span.filter-item-input-complete, textarea.filter-item-input-complete {
  color:#000;
}
textarea {
  max-height: 2.5em;
  line-height: inherit;
  padding: 0 0 0 0;
}
.filter-selection {
  z-index:150;
}

.icon {
  min-height: 20px;
  min-width: 20px;
}

i.icon.fa.fa-filter {
  line-height: inherit;
  font-size: 1.3em;
  padding-right: 15px;
}

#status-chevron {
  font-size: inherit;
  line-height: inherit;
  color:inherit;
}

.row {
  margin: 0;
}
</style>
